import type { BoqRow, EffectiveTotal } from '../../types'

export interface EffectiveTotalInput {
  totalPrice: number | null
  quantity: number | null
  unitPrice: number | null
}

function finiteOrNull(value: number | null): number | null {
  return value !== null && Number.isFinite(value) ? value : null
}

export function calculateEffectiveTotal(input: EffectiveTotalInput): EffectiveTotal {
  const original = finiteOrNull(input.totalPrice)
  if (original !== null) return { value: original, source: 'original' }

  const quantity = finiteOrNull(input.quantity)
  const unitPrice = finiteOrNull(input.unitPrice)
  if (quantity !== null && unitPrice !== null) {
    return { value: quantity * unitPrice, source: 'calculated' }
  }
  return { value: null, source: 'missing' }
}

export function withEffectiveTotal<T extends BoqRow>(row: T): T {
  const effective = calculateEffectiveTotal(row)
  return { ...row, effectiveTotalPrice: effective.value, totalPriceSource: effective.source }
}
